import * as React from 'react'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import {theme} from '../../config/Dashboardtheme'
import { useMediaQuery } from '@mui/material'
interface CenteredTabsProps {
  value: string
  handleChange: (event: React.SyntheticEvent, newValue: string) => void
  isGrantDateValid: boolean | '' | undefined
}

export default function CenteredTabs({
  value,
  handleChange,
  isGrantDateValid,
}: CenteredTabsProps) {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  return (
    <Tabs
      value={value}
      onChange={handleChange}
      centered
      sx={{
        marginBottom: 2,
        '& .MuiTabs-indicator': {
          backgroundColor: '#9135E0', // Purple indicator
        },
        '& .MuiTab-root': {
          // Default tab style
          color: '#000000',
          fontSize: isMobile? '13px':'16px',
          fontWeight: 500, // Black text for unselected tabs
          '&.Mui-selected': {
            // Selected tab style
            color: '#9135E0', // Purple text for selected tab
            fontWeight: 600,
          },
        },
      }}>
      <Tab label="Removal Stats" value={'Removal Stats'} />
      {isGrantDateValid && (
        <Tab label="Opt Out Requests" value={'Opt Out Requests'} />
      )}
    </Tabs>
  )
}